const ASSISTANT_DISMISSED = 'assistantDismissed';

export { ASSISTANT_DISMISSED };